<template>
  <div class="consumer-account-manage">
    <app-query-bar
      :queryConfig="queryConfig"
      v-model="queryData"
      @onSearch="fetchLogs" />
    <app-export-bar
      @onExport="onExport"
      @onExportAll="onExportAll" />
    <app-data-table
      :columns="LOG_COLUMNS"
      :data="logs"
      v-model="queryData"
      @onPageConfigChange="fetchLogs">
      <template
        slot-scope="{ row }"
        slot="type">
        {{ BASIC_OPERATION_TYPE_TEXT[row.type] }}
      </template>
    </app-data-table>
  </div>
</template>

<script>
import {
  LOG_COLUMNS,
  BASIC_OPERATION_TYPE_TEXT,
  OPERATION_TYPE,
  OPERATION_TYPE_OPTIONS,
} from './constants';
import ConsumerAccountLogApi from './consumer-account-log.api';
import DataTransferUtil from '@/utils/data-transfer.util';

export default {
  name: 'consumer-account-log',
  data() {
    return {
      LOG_COLUMNS,
      BASIC_OPERATION_TYPE_TEXT,
      queryConfig: [
        {
          fieldName: 'type',
          name: '操作类型',
          type: 'select',
          options: OPERATION_TYPE_OPTIONS,
        },
        {
          fieldName: 'customerNickName',
          name: '用户名',
        },
        {
          fieldName: 'mobile',
          name: '手机号',
        },
        {
          fieldName: 'optNickName',
          name: '操作人',
        },
      ],
      queryData: {
        page: 1,
        limit: 10,
        count: 0,
        type: OPERATION_TYPE.ALL,
        customerNickName: '',
        mobile: '',
        optNickName: '',
      },
      logs: [],
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      const {
        page,
        limit,
        type,
        customerNickName,
        mobile,
        optNickName,
      } = this.queryData;
      const {
        count = 0,
        results = [],
      } = await ConsumerAccountLogApi.getLogs(
        page,
        limit,
        type,
        customerNickName,
        optNickName,
        mobile,
      );
      this.logs = results;
      this.$set(this.queryData, 'count', count);
    },
    async onExport() {
      const {
        page,
        limit,
        type,
        customerNickName,
        mobile,
        optNickName,
      } = this.queryData;
      const key = await ConsumerAccountLogApi.export({
        page,
        limit,
        type,
        customer_nick_name: customerNickName,
        opt_nick_name: optNickName,
        mobile,
      });
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
    async  onExportAll() {
      const key = await ConsumerAccountLogApi.export();
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
  },
};
</script>

<style scoped>

</style>
